export type PkiCertificate = {
  keyUsageNumber: number;
  payload: Uint8Array;
};
